import React, { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import styles from '../../pages/Monitor/Monitor.module.css';

const ExpandableTile = ({
    title,
    icon,
    children,
    defaultExpanded = false,
    className = '',
    headerActions = null,
    style = {}
}) => {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);

    useEffect(() => {
        setIsExpanded(defaultExpanded);
    }, [defaultExpanded]);

    const toggleTile = () => {
        setIsExpanded(prev => !prev);
    };

    return (
        <div
            className={`
                ${styles.tile}
                ${isExpanded ? styles.expanded : ''}
                ${className}
            `}
            style={style}
        >
            <div
                className={styles.tileHeader}
                onClick={toggleTile}
            >
                <div className={styles.tileTitle}>
                    {icon && (
                        <span className={styles.tileIcon}>
                            {icon}
                        </span>
                    )}

                    <span>{title}</span>
                </div>

                <div className={styles.tileHeaderRight}>
                    {headerActions && (
                        <div
                            className={styles.headerActions}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {headerActions}
                        </div>
                    )}

                    <span className={styles.chevronIcon}>
                        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                </div>
            </div>

            {isExpanded && (
                <div className={styles.tileBody}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default ExpandableTile;